import SvgIcon, { SvgIconProps } from "./SvgIcon";

const ColoredSignpostIcon: React.FC<SvgIconProps> = ({ variant, ...props }) => {
  return (
    <SvgIcon viewBox="0 0 32 32" {...props}>
      {variant == "outlined" ? (
        <>
          <use xlinkHref="#stroke0_3376_469" fill="#262626" />
          <mask
            id="stroke1_3376_469"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="24"
            height="22"
            fill="black"
          >
            <rect fill="white" y="1" width="24" height="22" />
            <use xlinkHref="#stroke0_3376_469" />
          </mask>
          <path
            d="M22.7985 9.94712L19.4924 6.35577C19.3451 6.19545 19.1651 6.06723 18.964 5.97943C18.7628 5.89164 18.5451 5.84623 18.3249 5.84615H11.9974V2.76923C11.9974 2.56522 11.9147 2.36956 11.7674 2.2253C11.62 2.08104 11.4202 2 11.2119 2C11.0036 2 10.8038 2.08104 10.6565 2.2253C10.5091 2.36956 10.4264 2.56522 10.4264 2.76923V5.84615H2.57106C2.15439 5.84615 1.75479 6.00824 1.46015 6.29676C1.16552 6.58528 1 6.97659 1 7.38462V13.5385C1 13.9465 1.16552 14.3378 1.46015 14.6263C1.75479 14.9148 2.15439 15.0769 2.57106 15.0769H10.4264V21.2308C10.4264 21.4348 10.5091 21.6304 10.6565 21.7747C10.8038 21.919 11.0036 22 11.2119 22C11.4202 22 11.62 21.919 11.7674 21.7747C11.9147 21.6304 11.9974 21.4348 11.9974 21.2308V15.0769H18.3249C18.5451 15.0768 18.7628 15.0314 18.964 14.9436C19.1651 14.8558 19.3451 14.7276 19.4924 14.5673L22.7985 10.976C22.9282 10.8347 23 10.6515 23 10.4615C23 10.2716 22.9282 10.0883 22.7985 9.94712ZM18.3249 13.5385H2.57106V7.38462H18.3249L21.1528 10.4615L18.3249 13.5385Z"
            strokeWidth="0.6"
            stroke="#262626"
            mask="url(#stroke1_3376_469)"
          />
          <defs>
            <path
              id="stroke0_3376_469"
              d="M22.7985 9.94712L19.4924 6.35577C19.3451 6.19545 19.1651 6.06723 18.964 5.97943C18.7628 5.89164 18.5451 5.84623 18.3249 5.84615H11.9974V2.76923C11.9974 2.56522 11.9147 2.36956 11.7674 2.2253C11.62 2.08104 11.4202 2 11.2119 2C11.0036 2 10.8038 2.08104 10.6565 2.2253C10.5091 2.36956 10.4264 2.56522 10.4264 2.76923V5.84615H2.57106C2.15439 5.84615 1.75479 6.00824 1.46015 6.29676C1.16552 6.58528 1 6.97659 1 7.38462V13.5385C1 13.9465 1.16552 14.3378 1.46015 14.6263C1.75479 14.9148 2.15439 15.0769 2.57106 15.0769H10.4264V21.2308C10.4264 21.4348 10.5091 21.6304 10.6565 21.7747C10.8038 21.919 11.0036 22 11.2119 22C11.4202 22 11.62 21.919 11.7674 21.7747C11.9147 21.6304 11.9974 21.4348 11.9974 21.2308V15.0769H18.3249C18.5451 15.0768 18.7628 15.0314 18.964 14.9436C19.1651 14.8558 19.3451 14.7276 19.4924 14.5673L22.7985 10.976C22.9282 10.8347 23 10.6515 23 10.4615C23 10.2716 22.9282 10.0883 22.7985 9.94712ZM18.3249 13.5385H2.57106V7.38462H18.3249L21.1528 10.4615L18.3249 13.5385Z"
            />
          </defs>
        </>
      ) : (
        <>
          <use xlinkHref="#stroke0_3376_471" fill="#262626" />
          <mask
            id="stroke1_3376_471"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="24"
            height="22"
            fill="black"
          >
            <rect fill="white" y="1" width="24" height="22" />
            <use xlinkHref="#stroke0_3376_471" />
          </mask>
          <path
            d="M22.7985 9.94712L19.4924 6.35577C19.3451 6.19545 19.1651 6.06723 18.964 5.97943C18.7628 5.89164 18.5451 5.84623 18.3249 5.84615H11.9974V2.76923C11.9974 2.56522 11.9147 2.36956 11.7674 2.2253C11.62 2.08104 11.4202 2 11.2119 2C11.0036 2 10.8038 2.08104 10.6565 2.2253C10.5091 2.36956 10.4264 2.56522 10.4264 2.76923V5.84615H2.57106C2.15439 5.84615 1.75479 6.00824 1.46015 6.29676C1.16552 6.58528 1 6.97659 1 7.38462V13.5385C1 13.9465 1.16552 14.3378 1.46015 14.6263C1.75479 14.9148 2.15439 15.0769 2.57106 15.0769H10.4264V21.2308C10.4264 21.4348 10.5091 21.6304 10.6565 21.7747C10.8038 21.919 11.0036 22 11.2119 22C11.4202 22 11.62 21.919 11.7674 21.7747C11.9147 21.6304 11.9974 21.4348 11.9974 21.2308V15.0769H18.3249C18.5451 15.0768 18.7628 15.0314 18.964 14.9436C19.1651 14.8558 19.3451 14.7276 19.4924 14.5673L22.7985 10.976C22.9282 10.8347 23 10.6515 23 10.4615C23 10.2716 22.9282 10.0883 22.7985 9.94712Z"
            strokeWidth="0.6"
            stroke="#262626"
            mask="url(#stroke1_3376_471)"
          />
          <defs>
            <path
              id="stroke0_3376_471"
              d="M22.7985 9.94712L19.4924 6.35577C19.3451 6.19545 19.1651 6.06723 18.964 5.97943C18.7628 5.89164 18.5451 5.84623 18.3249 5.84615H11.9974V2.76923C11.9974 2.56522 11.9147 2.36956 11.7674 2.2253C11.62 2.08104 11.4202 2 11.2119 2C11.0036 2 10.8038 2.08104 10.6565 2.2253C10.5091 2.36956 10.4264 2.56522 10.4264 2.76923V5.84615H2.57106C2.15439 5.84615 1.75479 6.00824 1.46015 6.29676C1.16552 6.58528 1 6.97659 1 7.38462V13.5385C1 13.9465 1.16552 14.3378 1.46015 14.6263C1.75479 14.9148 2.15439 15.0769 2.57106 15.0769H10.4264V21.2308C10.4264 21.4348 10.5091 21.6304 10.6565 21.7747C10.8038 21.919 11.0036 22 11.2119 22C11.4202 22 11.62 21.919 11.7674 21.7747C11.9147 21.6304 11.9974 21.4348 11.9974 21.2308V15.0769H18.3249C18.5451 15.0768 18.7628 15.0314 18.964 14.9436C19.1651 14.8558 19.3451 14.7276 19.4924 14.5673L22.7985 10.976C22.9282 10.8347 23 10.6515 23 10.4615C23 10.2716 22.9282 10.0883 22.7985 9.94712Z"
            />
          </defs>
        </>
      )}
    </SvgIcon>
  );
};

export default ColoredSignpostIcon;
